var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAkarIconsCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M433.334 677.084L595.834 839.584L866.667 514.584",
    className: "svgStroke",
    strokeWidth: 60,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650.001 1191.67C949.155 1191.67 1191.67 949.155 1191.67 650.001C1191.67 350.846 949.155 108.334 650.001 108.334C350.846 108.334 108.334 350.846 108.334 650.001C108.334 949.155 350.846 1191.67 650.001 1191.67Z",
    className: "svgStroke",
    strokeWidth: 60
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsCircleCheck);
export default __webpack_public_path__ + "static/media/akar-icons_circle-check.9264686a75cbb7c8171ce974da428c57.svg";
export { ForwardRef as ReactComponent };